import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams, MenuController,AlertController, Platform,ModalController } from "ionic-angular";
import { HkApiproviderProvider } from "../../providers/hk-apiprovider/hk-apiprovider";
import { TranslateService } from '@ngx-translate/core';
import { LanguageServiceProvider } from '../../providers/language-service/language-service';
@IonicPage()
@Component({
  selector: "page-home",
  templateUrl: "home.html"
})
export class HomePage {
  public resposeData: any;
  userDetails:any;

  type:any;
  postData = {
    token: "",
    user_id:"",
    role:"",
    lang:"",
    id:"",
    country:"",
    prize:""
  };

  left_days:any;
  left_hours:any;
  left_minutes:any;
  left_seconds:any;

  static userPlatform:any;
  loginstatus = "Guest";
  public notibaseImageUrl:String;
  alert_message:any = [];
  responseData:any;
  static devWidth:any;
  windowWidth:any;
  myCount:any = 0;
  lucky_timer:any;
  timer:any;
  luckyData:any;
  luckyUserData:any;
  lucky_number:any;
  specialPrize:any;
  total:any;
  nextAwardData:any;
  prefix:any;
  public almsDonorMorning:any;
  public almsDonorLunch:any;
  awardbaseImageUrl:any;
  constructor(
    public navCtrl: NavController,
    private auth: HkApiproviderProvider,
    public navPram: NavParams,
    public alertCtrl: AlertController,
    public menuCtrl : MenuController,
    private translate: TranslateService,
    public langserv : LanguageServiceProvider,
    public navParams: NavParams,
    public modal: ModalController,
    public platform: Platform ) {
      HomePage.devWidth = this.platform.width();
      this.windowWidth = HomePage.devWidth;
      if(!localStorage.getItem('language')){
        localStorage.setItem('language','mm');
        this.navCtrl.setRoot("HomePage");
      }else{
        if(this.navPram.get('page_from')=='login'){
          setInterval(this.loadReset,500);
        }
        let language =  localStorage.getItem('language');
        translate.setDefaultLang(language);
        this.langserv.changelang(language);
        this.postData.token = HkApiproviderProvider.gettoken();
        this.postData.lang = language; 
        this.menuCtrl.enable(true);
        this.awardbaseImageUrl = this.auth.getAwardimage();
        if(localStorage.getItem('userData')){
          const data = JSON.parse(localStorage.getItem('userData'));
          this.userDetails = data.userData;
          this.loginstatus = this.userDetails.name;
          this.postData.user_id = this.userDetails.user_id;
          this.postData.role = this.userDetails.role;
          this.postData.country = this.userDetails.country;
          this.postData.token = this.userDetails.token;
          
          this.getLuckyNumber();
        } else{
          this.loginstatus = "Guest";
          this.getLuckyNumber()
        }
      }
    }
    /*
    getLuckyNumber(){
      console.log(this.postData);
      this.auth.postData(this.postData, "getLuckyData").then(
        result => {
          this.resposeData = result;
          this.luckyData = this.resposeData.luckyData;
          console.log(this.luckyData);
          if(this.luckyData){
            this.prefix = this.luckyData.prefix;
          
          this.luckyUserData = this.resposeData.luckyUserData;
          this.total = this.resposeData.totalData;
        //  this.nextAwardData = this.resposeData.nextAwardData;
          console.log(this.total);
          if(this.luckyUserData){
            this.luckyUserData.forEach(usr => {
              usr.ticketno = this.prefix+String(usr.id).padStart(6, '0');
            });
          }
          if(this.luckyData.status =='finished'){
            this.lucky_number =  "lucky_number_is";
            if(this.luckyData.lucky_number!=0){
              this.specialPrize = this.prefix+String(this.luckyData.lucky_number).padStart(6, '0');
              this.myCount = this.specialPrize;
            }
            if(this.luckyData.first_prize!=0){
              this.firstPrize = this.prefix+String(this.luckyData.first_prize).padStart(6, '0');
              this.myCount = this.firstPrize;
            }
            if(this.luckyData.second_prize!=0){
              this.secondPrize = this.prefix+String(this.luckyData.second_prize).padStart(6, '0');
              this.myCount = this.secondPrize;
            }
            if(this.luckyData.third_prize!=0){
              this.thirdPrize = this.prefix+String(this.luckyData.third_prize).padStart(6, '0');
              this.myCount = this.thirdPrize;
            }
            this.postData.id=this.luckyData.id;
          } else if( this.luckyData.status !="finished"){
            let open_date = Date.parse(this.luckyData.open_date);
            let current_date = Date.parse(this.luckyData.c_time);
              let interval = setInterval(()=>{
                current_date = current_date + 200;
               // console.log(open_date +"<="+ current_date);
                if(open_date <= current_date && this.luckyData.status !="finished"){
                  this.getLuckyNumber();
                } else if(this.luckyData.status !="finished"){
                  // To calculate the time difference of two dates
                  let Difference_In_Time = open_date - current_date;
                  // To calculate the no. of days between two dates
                  let delta = Difference_In_Time;
                  const days = Math.floor(delta / (86400*1000));
                  delta -= days * 86400;
                  const hours = Math.floor(delta / (3600*1000)) % 24;
                  delta -= hours * 3600;
                  const minutes = Math.floor(delta / (60*1000)) % 60;
                  delta -= minutes * 60;
                  const seconds = Math.floor((delta/1000) % 60);
      
                  this.left_days = this.auth.enToMyanmarNumber(""+days);
                  this.left_hours = this.auth.enToMyanmarNumber(""+hours);
                  this.left_minutes = this.auth.enToMyanmarNumber(""+minutes);
                  this.left_seconds = this.auth.enToMyanmarNumber(""+seconds);

    
                //  let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
                //  Math.random() * (max - min) + min;
                //  console.log(Difference_In_Days);
                  let min = Math.ceil(this.luckyData.min_ticket_no);
                  let max = Math.floor(this.luckyData.max_ticket_no);
                  let rand_number =  Math.floor(Math.random() * (max - min + 1) + min);
                  this.lucky_timer =  new Date().toISOString();
                  this.myCount = this.prefix+String(rand_number).padStart(6, '0');
                  this.specialPrize = this.prefix+String(rand_number).padStart(6, '0');
                } else {
                  clearInterval(interval);
                }
              },200)
            }
          }
        },
        err => {

        }
      );
        
    }
    drawNewNumber(){
      this.navCtrl.push("DrawNumberPage");
    }
    getOtherPrize(prize:string){
      let Difference_In_Time = 1000;
      let interval = setInterval(()=>{
        // To calculate the time difference of two dates
        Difference_In_Time = Difference_In_Time - 200 ;
        // To calculate the no. of days between two dates
        let delta = Difference_In_Time;
        const days = Math.floor(delta / (86400*1000));
        delta -= days * 86400;
        const hours = Math.floor(delta / (3600*1000)) % 24;
        delta -= hours * 3600;
        const minutes = Math.floor(delta / (60*1000)) % 60;
        delta -= minutes * 60;
        const seconds = Math.floor((delta/1000) % 60);

        this.left_days = this.auth.enToMyanmarNumber(""+days);
        this.left_hours = this.auth.enToMyanmarNumber(""+hours);
        this.left_minutes = this.auth.enToMyanmarNumber(""+minutes);
        this.left_seconds = this.auth.enToMyanmarNumber(""+seconds);
        let min = this.luckyData.min_ticket_no;
        let max = this.luckyData.max_ticket_no;
        let rand_number = Math.floor(Math.random() *  (max-min+1)+min);
        this.lucky_timer =  new Date().toISOString();
        this.myCount = this.prefix+String(rand_number).padStart(6, '0');
        if(prize=='first'){
          this.postData.firstPrize = rand_number;
        }
        if(prize=='second'){
          this.postData.secondPrize = rand_number;
        }
        if(prize=='third'){
          this.postData.thirdPrize = rand_number;
        }
        if(Difference_In_Time <= 0) {
          clearInterval(interval);
          let loader = this.auth.loadingMessage('message_Processing');
          loader.present();
          console.log(this.postData);
          this.auth.postData(this.postData, "updatePrize").then(
            result => {
              loader.dismiss();
              this.resposeData = result;
              if (this.resposeData.success) {
                  this.navCtrl.setRoot("HomePage");
                } 
            },
            err => {
              loader.dismiss();
            }
          );
        }
      },200);
            
    }
*/
getLuckyNumber(){
  console.log(this.postData);
  this.auth.postData(this.postData, "getLuckyData").then(
    result => {
      this.resposeData = result;
      this.luckyData = this.resposeData.luckyData;
      console.log(this.luckyData);
      if(this.luckyData){
        this.postData.id=this.luckyData.id;
        this.prefix = this.luckyData.prefix;
        this.luckyUserData = this.resposeData.luckyUserData;
        this.total = this.resposeData.totalData;
        this.nextAwardData = this.resposeData.nextAwardData;
        if(this.luckyUserData.length != 0){
          this.myCount = this.prefix+String(this.luckyUserData[0].lucky_number).padStart(6, '0');
        }
        let open_date = Date.parse(this.luckyData.open_date);
        let current_date = Date.parse(this.luckyData.c_time);

        let interval = setInterval(()=>{
          current_date = current_date + 200;
          // console.log(open_date +"<="+ current_date);
          if(open_date >= current_date){
            // To calculate the time difference of two dates
            let Difference_In_Time = open_date - current_date;
            // To calculate the no. of days between two dates
            let delta = Difference_In_Time;
            const days = Math.floor(delta / (86400*1000));
            delta -= days * 86400;
            const hours = Math.floor(delta / (3600*1000)) % 24;
            delta -= hours * 3600;
            const minutes = Math.floor(delta / (60*1000)) % 60;
            delta -= minutes * 60;
            const seconds = Math.floor((delta/1000) % 60);

            this.left_days = this.auth.enToMyanmarNumber(""+days);
            this.left_hours = this.auth.enToMyanmarNumber(""+hours);
            this.left_minutes = this.auth.enToMyanmarNumber(""+minutes);
            this.left_seconds = this.auth.enToMyanmarNumber(""+seconds);
          } else {
            this.timer = 'finished';
            clearInterval(interval);
          }
        },200)

        if(this.luckyUserData){
          this.luckyUserData.forEach(usr => {
            usr.ticketno = this.prefix+String(usr.lucky_number).padStart(6, '0');
          });
        }
      }
    },
    err => {
    }
  );
    
}
drawNewNumber(){
  this.navCtrl.push("DrawNumberPage");
}
getOtherPrize(prize:string){
  let Difference_In_Time = 20000;
  let interval = setInterval(()=>{
    // To calculate the time difference of two dates
    Difference_In_Time = Difference_In_Time - 200 ;
    // To calculate the no. of days between two dates
    let delta = Difference_In_Time;
    const days = Math.floor(delta / (86400*1000));
    delta -= days * 86400;
    const hours = Math.floor(delta / (3600*1000)) % 24;
    delta -= hours * 3600;
    const minutes = Math.floor(delta / (60*1000)) % 60;
    delta -= minutes * 60;
    const seconds = Math.floor((delta/1000) % 60);

    this.left_days = this.auth.enToMyanmarNumber(""+days);
    this.left_hours = this.auth.enToMyanmarNumber(""+hours);
    this.left_minutes = this.auth.enToMyanmarNumber(""+minutes);
    this.left_seconds = this.auth.enToMyanmarNumber(""+seconds);
    let min = this.luckyData.min_ticket_no;
    let max = this.luckyData.max_ticket_no;
    let rand_number = Math.floor(Math.random() *  (max-min+1)+min);
    this.lucky_timer =  new Date().toISOString();
    this.myCount = this.prefix+String(rand_number).padStart(6, '0');
    this.postData.prize=prize;
    if(Difference_In_Time <= 0) {
      clearInterval(interval);
      let loader = this.auth.loadingMessage('message_Processing');
      loader.present();
      console.log(this.postData);
      this.auth.postData(this.postData, "updatePrize").then(
        result => {
          loader.dismiss();
          this.resposeData = result;
          if (this.resposeData.success) {
              this.navCtrl.setRoot("HomePage");
            } 
        },
        err => {
          loader.dismiss();
        }
      );
    }
  },200);
        
}
    changeLanguage(){
      this.navCtrl.push("IntroPage");
    }
    loadReset(){
      window.location.reload();
    }
    dologout(){
      localStorage.removeItem('userData');
      this.navCtrl.setRoot("HomePage");
    }
    gotoLoginPage(){
        this.navCtrl.setRoot("LoginPage");
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts